export type CodeTemplate =
  | "shell"
  | "python"
  | "typescript"
  | "react"
  | "agent";

type TemplateStep = {
  entryPoint?: string;
  defaultHasOutput: boolean;
};

export const templateSteps: Record<CodeTemplate, TemplateStep> = {
  shell: { entryPoint: "script.sh", defaultHasOutput: false },
  python: { entryPoint: "script.py", defaultHasOutput: false },
  typescript: { entryPoint: "script.ts", defaultHasOutput: false },
  react: { entryPoint: "App.tsx", defaultHasOutput: true },
  agent: { entryPoint: "agent.ts", defaultHasOutput: false },
};
